import { render, staticRenderFns } from "./CreatePlusTemplateSlide.vue?vue&type=template&id=00083383&scoped=true&"
import script from "./CreatePlusTemplateSlide.vue?vue&type=script&lang=js&"
export * from "./CreatePlusTemplateSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00083383",
  null
  
)

export default component.exports